"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentInvoiceEditPopup = exports.allotmentInvoiceEditPopupEffects = exports.allotmentInvoiceEditPopupConfig = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../utils/dateTime");
const Field_1 = require("../../Form/Field");
const stable_1 = require("../../Form/Field/Date/stable");
const Select_1 = require("../../Form/Field/Select");
const Confirm_1 = require("../../Popup/Confirm");
require("./index.scss");
const className = 'allotment-invoice-edit-popup';
const allotmentInvoiceCompanyLabels = {
    'Gmbh': 'Gmbh',
    'SH.P.K': 'SH.P.K',
};
const allotmentInvoiceEditPopupConfig = (value) => ({
    type: 'object',
    shape: {
        title: {
            type: 'string',
        },
        invoiceDate: {
            type: 'date',
            dateRestrictions: {
                nextYearsCount: dateTime_1.bookingNextYearsCount,
                pastYearsCount: dateTime_1.bookingPastYearsCount,
            },
        },
        paymentDeadline: {
            type: 'date',
            dateRestrictions: {
                nextYearsCount: dateTime_1.bookingNextYearsCount,
                pastYearsCount: dateTime_1.bookingPastYearsCount,
                notAllowedBeforeDate: value === null || value === void 0 ? void 0 : value.invoiceDate,
            },
        },
        invoiceCompany: {
            type: 'string',
            items: [
                'Gmbh',
                'SH.P.K',
            ],
        },
        discountDescription: {
            type: 'string',
            optional: true,
        },
        discount: {
            type: 'number',
            optional: true,
            positive: true,
            roundedMoney: true,
        },
    },
});
exports.allotmentInvoiceEditPopupConfig = allotmentInvoiceEditPopupConfig;
exports.allotmentInvoiceEditPopupEffects = [
    {
        target: ['invoiceDate'],
        dependent: [
            ['paymentDeadline'],
        ],
    },
];
const AllotmentInvoiceEditPopup = (props) => {
    const { title, field, onConfirm, onClose, isOpened, isLoading, isConfirmDisabled } = props;
    const popupConfirmProps = {
        isOpened,
        isLoading,
        onConfirm,
        onClose,
        isConfirmDisabled,
        confirmMessage: title,
        modificators: 'no-scrolling',
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Confirm_1.PopupConfirm, { ...popupConfirmProps },
            react_1.default.createElement("div", { className: `${className}__fields` },
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['title']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/title:label', defaultMessage: 'Title' }) }),
                react_1.default.createElement(stable_1.FormFieldDateStable, { ...field(['invoiceDate']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/invoiceDate:label', defaultMessage: 'Invoice Date' }) }),
                react_1.default.createElement(stable_1.FormFieldDateStable, { ...field(['paymentDeadline']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/paymentDeadline:label', defaultMessage: 'Due Date' }) }),
                react_1.default.createElement(Select_1.FormFieldSelect, { ...field(['invoiceCompany']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/invoiceCompany:label', defaultMessage: 'Invoice Company' }), toItem: (itemValue) => ({
                        value: itemValue,
                        label: allotmentInvoiceCompanyLabels[itemValue],
                    }) }),
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['discountDescription']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/discountDescription:label', defaultMessage: 'Discount Description' }) }),
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['discount']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/List/CreateInvoicePopup/Field/discount:label', defaultMessage: 'Discount' }) })))));
};
exports.AllotmentInvoiceEditPopup = AllotmentInvoiceEditPopup;
//# sourceMappingURL=index.js.map